import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function TransferCancelDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !loading && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ຍົກເລີກຄຳຂໍ</DialogTitle>
          <DialogDescription>
            {requestNo} — ສະຖານະຈະເປັນຍົກເລີກ · ບໍ່ມີການຕັດສະຕ໋ອກ Hub
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            ກັບຄືນ
          </Button>
          <Button
            variant="destructive"
            isLoading={loading}
            onClick={() => void onConfirm()}
          >
            ຢືນຢັນຍົກເລີກ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
